import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch, withInterceptors, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig, importProvidersFrom, provideZoneChangeDetection } from '@angular/core';
import { BrowserAnimationsModule, provideAnimations } from "@angular/platform-browser/animations";
import { provideRouter, withHashLocation } from '@angular/router';
import { 
  MSAL_GUARD_CONFIG, MSAL_INSTANCE, MSAL_INTERCEPTOR_CONFIG, 
  MsalBroadcastService, MsalGuard, MsalGuardConfiguration, 
  MsalInterceptor, MsalInterceptorConfiguration, MsalService 
} from '@azure/msal-angular';
import { 
  BrowserCacheLocation, InteractionType, IPublicClientApplication, 
  LogLevel, PublicClientApplication 
} from '@azure/msal-browser';

import { BasicAuthInterceptor } from './shared/services/http.interceptor';
import { environment } from '../environments/environment';
import { routes } from './app.routes';
import { homeroutes } from './home/home.routes';
import { GenericLoaderService } from '@shared/generic-loader/generic-loader.service';

export function loggerCallback(logLevel: LogLevel, message: string) {
//  console.log(message);
}

export function MSALInstanceFactory(): IPublicClientApplication {
  return new PublicClientApplication({
    auth: { ...structuredClone(environment.msalConfig.auth) },
    cache: { cacheLocation: BrowserCacheLocation.LocalStorage },
    system: {
      allowNativeBroker: false, 
      loggerOptions: { loggerCallback, logLevel: LogLevel.Info, piiLoggingEnabled: false },
    },
  });
}

export function MSALInterceptorConfigFactory(): MsalInterceptorConfiguration {
  const protectedResourceMap = new Map([
    [environment.apiConfig.uri, environment.apiConfig.scopes]
  ]);
  return { interactionType: InteractionType.Redirect, protectedResourceMap };
}

export function MSALGuardConfigFactory(): MsalGuardConfiguration {
  return {
    interactionType: InteractionType.Redirect,
    authRequest: { scopes: environment.apiConfig.scopes },
  };
}

export const appConfig: ApplicationConfig = {
  providers: [
    GenericLoaderService,
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideHttpClient(withInterceptors([BasicAuthInterceptor]), withInterceptorsFromDi(), withFetch()),
    provideRouter([...routes, ...homeroutes], withHashLocation()),
    provideAnimations(),
    importProvidersFrom(BrowserAnimationsModule, CommonModule),
    { provide: HTTP_INTERCEPTORS, useClass: MsalInterceptor, multi: true },
    { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
    { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
    { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
    MsalService,
    MsalGuard,
    MsalBroadcastService,
  ]
};